import React from 'react'

export default function ContentProjects() {
  return (
    <div className="container-fluid">
        <div className="row">
            {/* <!-- Content Column --> */}
            <div className="card shadow-sm">
        <div className="card-header bg-white d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Recent Orders</h5>
          <button className="btn btn-primary btn-sm">View All</button>
        </div>
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-hover mb-0">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Customer</th>
                  <th>Product</th>
                  <th>Date</th>
                  <th>Status</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Rahul Sharma</td>
                  <td>iPhone 15</td>
                  <td>2025-09-22</td>
                  <td><span className="badge bg-success">Completed</span></td>
                  <td>₹80,000</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Priya Verma</td>
                  <td>Samsung Galaxy</td>
                  <td>2025-09-21</td>
                  <td><span className="badge bg-warning text-dark">Pending</span></td>
                  <td>₹55,000</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>Amit Patel</td>
                  <td>HP Laptop</td>
                  <td>2025-09-20</td>
                  <td><span className="badge bg-danger">Cancelled</span></td>
                  <td>₹45,000</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>Neha Gupta</td>
                  <td>AirPods Pro</td>
                  <td>2025-09-19</td>
                  <td><span className="badge bg-info text-dark">Processing</span></td>
                  <td>₹18,000</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
        </div>

    </div>
    
  )
}
